import React from 'react';
import { getLanguageId, setLanguage } from '../../lib/Utils';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { languages } from '../../config/AppConfig';
import { Colors, StyledComponents } from '../../themes';

import SvgIcon from '../../icons/SvgIcon';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const { ContentLabel } = StyledComponents;

const useStyles = makeStyles((theme) => ({
  languageTitle: {
    paddingLeft: 20,
    color: Colors.blackText,
    marginBottom: 6,
  },
  menu: {
    '& div.MuiPaper-root': {
      padding: '10px 0',
      width: 200,
      color: Colors.black,
      background: Colors.white,
      '& ul > li.MuiListItem-button': {
        paddingLeft: 30,
        '&:hover, &.active': {
          color: Colors.blue,
          fontWeight: 700,
          background: Colors.lightHoverGrey,
        },
      },
    },
  },
}));

export default function LanguageSelector() {
  const currentLanguageId = getLanguageId();
  const classes = useStyles();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleButtonClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleListItemClick = (languageId) => {
    handleClose();
    setLanguage(languageId);
  };

  return (
    <div>
      <IconButton
        color="inherit"
        aria-controls="language-menu"
        edge="end"
        aria-haspopup="true"
        onClick={handleButtonClick}
      >
        <SvgIcon icon={'Settings'} width={40} color={Colors.lightGreyOnBlack} />
      </IconButton>
      <Menu
        className={classes.menu}
        id="language-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <ContentLabel className={classes.languageTitle}>{t('language.language')}</ContentLabel>
        {languages.map((language) => (
          <MenuItem
            key={language.id}
            className={language.id === currentLanguageId ? 'active' : 'inactive'}
            button
            onClick={() => handleListItemClick(language.id)}
          >
            {language.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
